<template>
    <v-main >
        <v-layout  justify-space-between>
            
            <v-flex lg6 xs12 v-show="!swipeDirection"  >

                   <v-card class="elevation-0 scroll-right px-lg-10 py-lg-5 px-2 py-5" v-touch="{left: () => swipe('Left'),right: () => swipe('Right'),}">
                    
                       <span class="font-weight-black text-lg-body-1 text-body-2">
                           Instructor Class Handling Assessment 
                       </span>

                       <classAssestment  :mo-num="$route.params.mo" :tutor-name="tutorName" :week-score="weekScores" :bus="bus" ref="classAssesments" v-on:itemClick="getTabValue($event)" v-on:getInfoFromAssessment="getInfoFromAssessment($event)"  v-on:getMonthAssessment="getMonthAssessment($event)"/>
                    
                   </v-card>
                         
            </v-flex>



            
            <v-flex lg6 xs12 px-lg-10 px-5 mt-lg-n1  d-lg-flex v-show="swipeDirection" v-touch="{left: () => swipe('Left'),right: () => swipe('Right'),}" class="boxbg scroll-left scrollUp " >
                      <div class="mt-5"> 
                            

                            <weeklyForm v-if="tabValue=='WEEKLY'" :wk-report='wkReport' :week-value="weekValue" v-on:updateWeek="updatedWeek($event)"/>
                            <monthlyForm v-if="tabValue=='MONTHLY'" :mo-report='moReport' :month-value="monthValue" v-on:updateMonth="updatedMonth($event)" class="ml-lg-n7"/>


                      </div>
            </v-flex>
            
     </v-layout>
    </v-main>
</template>

<script >
import Vue from 'vue'
import axios from 'axios'
import classAssestment from '@/components/MonitoringRating/Performance/classHandlingAssestment'
import weeklyForm from '@/components/MonitoringRating/Performance/classHandling/weeklyForm'
import monthlyForm from '@/components/MonitoringRating/Performance/classHandling/monthlyForm'
Vue.use(axios)
export default {
    name: 'classHandlingForm',
    components:{
     classAssestment,
     weeklyForm,
     monthlyForm,
    },
    data: () => {
        return {
            dialogshow:false,
            swipeDirection: false,
            teams:'',
            tabValue:'WEEKLY',
            wkReport: new Vue(),
            weekValue:'',
            bus: new Vue(),
            tutorName:'',
            submitData:'',
            moReport: new Vue(),
            monthValue:'',
        }
    },

    computed: {
        
    },
    mounted(){

        axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          let tutorlist = response.data
        

              for(let i = 0 ; i<=tutorlist.length ; i++){
                    


                    if(this.$route.params.t_id.toString().toLowerCase().indexOf(tutorlist[i].tutor_id.toLowerCase()) !== -1){
                        this.tutorName = tutorlist[i].tutor_name
                    }

               }
               
              })

             
        
    },
    watch:{
        
    },
    
    methods: {

        updatedWeek(data){

            Vue.prototype.$submitData = data
            this.bus.$emit('sendUpdateWeek')
        },

        updatedMonth(data){
            Vue.prototype.$submitData = data
            this.bus.$emit('sendUpdateMonth')
        },

        getInfoFromAssessment(id){
            this.weekValue = []
            this.weekValue = id
            this.wkReport.$emit('getInfoAssessment')

        },

        getMonthAssessment(id){
            this.monthValue = []
            this.monthValue = id
            this.moReport.$emit('getMonthAssessment')
        },

        getTabValue(item){

           this.tabValue = item
        },


        pauseAudioPro(){
            Vue.prototype.$audiopro.pause();
            Vue.prototype.$audiopro.currentTime = 0 ;
        },
        swipe(direction) {

            if (direction == 'Left') {
                this.swipeDirection = true;
            } else if (direction == 'Right') {
                this.swipeDirection = false;
            }
        }
    },
}

</script>
<style scoped>

</style>
<style scoped>

.boxbg {
    background-color:#F6F6F6 !important;
}
.monsterrat{
   font-family: 'Montserrat', serif !important;
}
html {
    font-family: 'Montserrat', serif !important;
    overflow-y: hidden !important;
}
.input-size{
    max-width: 142px !important;
}
.select-input{
    max-width: 142px !important;
}
.header{
    background-color:#E5E5E5;
    
}
.criteria{
    background-color: white !important;
}
@media only screen and (max-width: 1200px) {
.input-size{
            max-width: 100% !important;
}
.select-input{
    max-width: 82% !important;
}
.header{
    width: 100% !important;
    
}
}
</style>